<template>
  <div class="ticket-romancecar mb-foot-2button">
    <!-- ヘッダー -->
    <MFITTHeader headerTitle="払いもどし" />

    <hr />

    <!-- 購入情報-->
    <div class="content-block-info">
      <div class="block">
        <!-- 乗車日 -->
        <ViBoardingDate :boardingDate="myLimitedExpressTicket.boarding_date" />

        <!-- 列車名 -->
        <ViTrainInfo :name="myLimitedExpressTicket.train.name"
          :carsFormationName="myLimitedExpressTicket.train.cars_formation.name" />

        <!-- 区間 -->
        <ViStationSection :from="myLimitedExpressTicket.from_station.name"
          :to="myLimitedExpressTicket.to_station.name" />

        <!-- 時間 -->
        <ViDepartureAndArrival :departure="myLimitedExpressTicket.departure_at"
          :arrival="myLimitedExpressTicket.arrival_at" />

        <!-- 座席種類 -->
        <StoreSeatType :selectedSeats="myLimitedExpressTicket.seats"
          :selectedExclusiveCars="myLimitedExpressTicket.train.cars_formation.cars" />
      </div>
    </div>

    <hr class="hr" />

    <div class="content-block-seats">
      <div class="block">
        <!-- 座席 -->
        <MFITTRefundSeats :seats="refundSeats" />
      </div>
    </div>

    <hr class="hr" />

    <div class="content-block-prices">
      <div class="block">
        <!-- 払いもどし金額 -->
        <MFITTRefundPrices :price="totalRefundPrice" :refundFee="totalRefundFee" />
      </div>
    </div>

    <!-- アクションボタン -->
    <div class="refund-foot-button-block">
      <ItemButton actionType="btn-primary" label="払いもどす" @clicked="refundTicket" />
      <ItemButton actionType="btn-cancel" label="戻る" @clicked="backToPreviousPage" />
    </div>
  </div>

  <!-- 払い戻し完了ダイアログ -->
  <DialogRefundCompleted ref="DialogRefundCompleted" :closeButtonClicked="backToMfittIndexPage" />

  <!-- 発車1分経過後、払戻不可のダイアログ -->
  <DialogCanNotRefundAfterDeparture ref="DialogCanNotRefundAfterDeparture" />

  <!-- チケット情報更新の失敗時のダイアログ -->
  <DialogTicketRefundError ref="DialogTicketRefundError" />

  <!-- 電波状況が悪い場合のダイアログ　-->
  <DialogBadReception ref="DialogBadReception" />

  <DialogDuringMaintenance ref="DialogDuringMaintenance" />

  <DialogUnexpectedError ref="DialogUnexpectedError" />

  <DialogConfirmRefundlApplication ref="DialogConfirmRefundlApplication" @confirmRefundApplication="confirmRefundApplication" />
  <DialogRefundApplicationCompleted ref="DialogRefundApplicationCompleted" :closeButtonClicked="backToMfittIndexPage" />

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" :timeoutSeconds="21000" />
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import mfittService from "@/services/MFITT";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateMfittMyTicketRefunc",
  setup() {
    const store = useStore();
    const router = useRouter();

    const DialogRefundCompleted = ref(null);
    const DialogCanNotRefundAfterDeparture = ref(null);
    const DialogTicketRefundError = ref(null);
    const DialogBadReception = ref(null);
    const DialogUnexpectedError = ref(null);
    const DialogDuringMaintenance = ref(null);
    const DialogLoading = ref(null);
    const DialogConfirmRefundlApplication = ref(null);
    const DialogRefundApplicationCompleted = ref(null);

    const myLimitedExpressTicket = computed(
      () => store.getters["MFITT/myLimitedExpressTicket"]
    );
    const refundSeats = computed(() => store.getters["MFITT/refundSeats"]);
    const refundAdultCount = ref(0); // 払い戻し席数(大人)
    const refundChildCount = ref(0); // 払い戻し席数(子供)
    const totalRefundFee = ref(0); // 払い戻し手数料
    const totalRefundPrice = ref(0); // 払い戻し金額

    const isUsedAlipay = mfittService.isAlipayCommodityCode(
      myLimitedExpressTicket.value.commodity_code
    );

    const handleRefundTicketError = (e) => {
      // 電波がない場合、e.response.data.messageが存在しない
      // loadingを表示し続け、そちらでタイムアウトさせる
      if(e.response.data.message) {
        DialogLoading.value.closeDialog();
        console.log("Error in postRefundTicket", e);
        // 払い戻し期限を過ぎている場合
        if(e.response.data.message===
          "invalid_cancel指定された特急券の列車は既に発車済みの為、払戻できません") {
          DialogCanNotRefundAfterDeparture.value.openDialog();
          // チケット情報更新のエラー
        } else if(e.response.data.error==="payment_error") {
          DialogTicketRefundError.value.openDialog();
          // MWのメンテナンス中
        } else if(e.response.data.message==="回線が込み合っています") {
          DialogBadReception.value.openDialog();
          // MWのメンテナンス中
        } else if(e.response.status==503) {
          DialogDuringMaintenance.value.openDialog(e.response.data);
        } else {
          // nativeにエラー内容送信
          nativeHandlerService.ncSendMfittError(e.response.data.message);
          DialogUnexpectedError.value.openDialog();
        }
      } else {
        nativeHandlerService.ncSendMfittError(
          "TemplateMfittMyTicketRefundConfirmation refundTicket()"
        );
      }
    };

    const confirmRefundApplication = async () => {
      try {
        DialogConfirmRefundlApplication.value.closeDialog();
        DialogLoading.value.openDialog();
        await API.postRefundTicket(
          myLimitedExpressTicket.value.id,
          makeApiParams()
        );
        DialogLoading.value.closeDialog();
        DialogRefundApplicationCompleted.value.openDialog();
      } catch (e) {
        handleRefundTicketError(e);
      }
    };

    const refundTicket = async () => {
      // ローディングダイアログ
      try {
        if (isUsedAlipay){
          openDialogConfirmRefundlApplication();
        } else {
          DialogLoading.value.openDialog();
          await API.postRefundTicket(
            myLimitedExpressTicket.value.id,
            makeApiParams()
          );
          DialogLoading.value.closeDialog();
          DialogRefundCompleted.value.openDialog();
        }
      } catch (e) {
        handleRefundTicketError(e);
      }
    };

    const makeApiParams = () => {
      let seats = [];
      refundSeats.value.forEach((seat) => {
        seats.push({ number: seat.seat_number });
      });
      let params;
      // 座席を指定して一部払戻し(is_partial_refund: true)
      if (
        myLimitedExpressTicket.value.seats.length !== refundSeats.value.length
      ) {
        params = {
          cancel_reason: "refund",
          is_partial_refund: true,
          adult_count: refundAdultCount.value,
          child_count: refundChildCount.value,
          seats: seats,
        };
        // サルーンの場合はsaloon_countも設定。
        if (myLimitedExpressTicket.value.saloon_count) {
          params["saloon_count"] = refundSeats.value.length;
        }
      } else {
        // 全席払戻し
        params = {
          cancel_reason: "refund",
          is_partial_refund: false,
        };
      }
      return params;
    };

    const backToPreviousPage = () => {
      router.go(-1);
    };

    const backToMfittIndexPage = () => {
      nativeHandlerService.returnNativeAppMfittIndexPage();
    };

    const openDialogConfirmRefundlApplication = async () => {
      DialogConfirmRefundlApplication.value.openDialog();
    };

    onMounted(() => {
      // division毎の払い戻し席数・料金を計算

      // サルーンの場合
      if (myLimitedExpressTicket.value.saloon_count) {
        // division毎の払い戻し席数を計算
        // まずは払い戻し人数の合計(おとな+こども)を計算
        let totalRefundCount = 0;
        // 現在の合計人数が4の倍数の場合は、単純に払い戻し席数×4
        if (
          (myLimitedExpressTicket.value.adult_count +
            myLimitedExpressTicket.value.child_count) %
          4 ==
          0
        ) {
          totalRefundCount = refundSeats.value.length * 4;
          // 4の倍数でない場合。払戻人数が最小になるように計算
          // 例) 現在の人数 | 払戻席数 | 払戻人数
          //        7     |    1    |    3
          //        2     |    1    |    2
        } else {
          totalRefundCount =
            (myLimitedExpressTicket.value.adult_count +
              myLimitedExpressTicket.value.child_count) %
            (refundSeats.value.length * 4);
        }
        // 子供から優先的に払い戻し
        if (myLimitedExpressTicket.value.child_count > totalRefundCount) {
          refundAdultCount.value = 0;
          refundChildCount.value = totalRefundCount;
        } else {
          refundAdultCount.value =
            totalRefundCount - myLimitedExpressTicket.value.child_count;
          refundChildCount.value = myLimitedExpressTicket.value.child_count;
        }

        // 払い戻し手数料を計算(サルーンの場合はdivision関係なく、adult_refund_feeをみる)
        totalRefundFee.value =
          refundSeats.value.length *
          myLimitedExpressTicket.value.adult_refund_fee;

        // 払い戻し金額を計算(サルーンの場合はdivision関係なく、adult_unit_priceをみる)
        totalRefundPrice.value =
          refundSeats.value.length *
          myLimitedExpressTicket.value.adult_unit_price;

        // サルーン以外の場合
      } else {
        // division毎の払い戻し席数を計算
        let adultCount = 0;
        let childCount = 0;
        refundSeats.value.forEach((seat) => {
          if (seat.price_division == "adult") {
            adultCount++;
          } else if (seat.price_division == "child") {
            childCount++;
          }
        });
        refundAdultCount.value = adultCount;
        refundChildCount.value = childCount;

        // 払い戻し手数料を計算
        totalRefundFee.value =
          adultCount * myLimitedExpressTicket.value.adult_refund_fee +
          childCount * myLimitedExpressTicket.value.child_refund_fee;

        // 払い戻し金額を計算
        totalRefundPrice.value =
          adultCount * myLimitedExpressTicket.value.adult_unit_price +
          childCount * myLimitedExpressTicket.value.child_unit_price;
      }
    });

    return {
      myLimitedExpressTicket,
      refundSeats,
      refundTicket,
      totalRefundFee,
      totalRefundPrice,
      backToPreviousPage,
      backToMfittIndexPage,
      openDialogConfirmRefundlApplication,
      confirmRefundApplication,
      handleRefundTicketError,
      DialogRefundCompleted,
      DialogCanNotRefundAfterDeparture,
      DialogTicketRefundError,
      DialogLoading,
      DialogBadReception,
      DialogUnexpectedError,
      DialogDuringMaintenance,
      DialogConfirmRefundlApplication,
      DialogRefundApplicationCompleted,
      isUsedAlipay,
    };
  },
};
</script>

<style>
.hr {
  width: 95%;
  text-align: center;
  margin: 10px auto;
}
.title-block {
  margin: 20px 12px 16px;
  font-size: 15px;
  text-align: left;
  line-height: 18px;
  color: #000000;
  font-weight: bold;
}
.ticket-romancecar .content-block-info {
  width: 100%;
  padding: 0 0 16px;
}
.ticket-romancecar .content-block-info .block {
  display: table;
  font-size: 13px;
}
.ticket-romancecar .content-block-seats {
  width: 100%;
  padding: 0 0 16px;
  margin-top: 20px;
}
.ticket-romancecar .content-block-seats .block {
  display: table;
  font-size: 13px;
}
.ticket-romancecar .content-block-prices {
  width: 100%;
  padding: 0 0 16px;
  margin-bottom: 200px;
}
.ticket-romancecar .content-block-prices .block {
  font-size: 13px;
}
.refund-foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 90%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}
</style>
